import { taxSavingsRestrictedStates } from '@carvana/merch-contracts';
import { useUserLocation } from '~/context/common/UserContext';

export default function useGetIsInTaxSavingRestrictedState() {
  const { state } = useUserLocation();

  return taxSavingsRestrictedStates.includes(state);
}
